import { Suspense, lazy } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Loader } from '@/shared/ui/loader'

const SpecializedDonorsPage = lazy(
  () => import('@/pages/specialized-donors/ui/index'),
)

export const Route = createFileRoute('/_protected/specialized-donors')({
  component: () => (
    <Suspense fallback={<Loader />}>
      <SpecializedDonorsPage />
    </Suspense>
  ),
})
